import React from 'react'
import './404.scss'

function NotFound() {
  return (
    <div className="not-found">
      <h2>404</h2>
    </div>
  )
}

export default NotFound